import Vue from 'vue';

const caseEventBus = new Vue();

export default caseEventBus;